"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var no_image_png_1 = __importDefault(require("images/no_image.png"));
var RecommendedImportCategory = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { onClick: store.handleCardClick, className: "estimateForm-ItemInputCardList_RecommendedImportCategoryWrapper" },
        react_1.default.createElement("div", { className: "estimateForm-ItemInputCardList_RecommendedImportCategoryName" }, store.name),
        react_1.default.createElement("div", { className: "estimateForm-ItemInputCardList_RecommendedImportCategoryImageWrapper" },
            react_1.default.createElement("img", { src: store.imageUrl || no_image_png_1.default, className: "estimateForm-ItemInputCardList_RecommendedImportCategoryImage lazyload" })),
        react_1.default.createElement("div", { className: "estimateForm-ItemInputCardList_RecommendedImportCategoryFooter" },
            react_1.default.createElement("span", { className: "estimateForm-ItemInputCardList_RecommendedImportCategoryFooterIcon jirafficon jirafficon-plus" }),
            "\u67FB\u5B9A\u3059\u308B")));
});
exports.default = RecommendedImportCategory;
